import { render } from "./terms.vue?vue&type=template&id=a8836d78&ts=true"
import script from "./terms.vue?vue&type=script&lang=ts"
export * from "./terms.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__